/**
 * Export all controls from the tabs block.
 */
export { default as Settings } from './settings';
export { default as Styles } from './styles';
